<script setup>

import { defineProps, defineEmits, ref, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilObject from "@/utils/UtilObject";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "visualizandoDado",
    "dadoOriginal"
]);

const emits = defineEmits([
    "update:alteraVisualizandoDado",
]);

//==================================================================//
//============================= Dado ===============================//
//==================================================================//

let dado = ref({});

//==================================================================//
//=================== Altera Visualizando Dado =====================//
//==================================================================//

const alteraVisualizandoDado = (update) =>{

    emits('update:alteraVisualizandoDado',update);

};

//==================================================================//
//========================== Altera Dado ===========================//
//==================================================================//

const alteraDado = (update = {})=>{

    dado.value = UtilObject.merge(dado.value, update);

};

//==================================================================//
//======================= Altera ContaAPagar =======================//
//==================================================================//

const alteraContaAPagar = (update)=>{

    let contasAPagar = dado?.value?.contasAPagar?.map((contaAPagar)=>{

        if(contaAPagar?.id != update.id){
            return contaAPagar;
        }

        return{
            ...contaAPagar,
            ...update
        }

    });

    alteraDado({
        contasAPagar: contasAPagar
    });

};

//===================================================================//
//========================== Prepara Dado ===========================//
//=================================================-=================//

const preparaDado = (dado = {})=>{

    let contasAPagar = dado?.parcelas?.map((parcela)=>{

        let contaAPagar = parcela?.contaAPagar;

        let pagamentos = contaAPagar?.pagamentos?.map((pagamento)=>{

            return{
                id: pagamento?.id || "",
                tipo: pagamento?.tipo || "",
                sequencia: pagamento?.sequencia || "",
                status: pagamento?.status || "",
                notaFiscalRecebidaID: pagamento?.notaFiscalRecebida?.id || "", 
                notaFiscalRecebidaNumero: pagamento?.notaFiscalRecebida?.numero || "",
                notaFiscalRecebidaChaveAcesso: pagamento?.notaFiscalRecebida?.chaveAcesso || "",
                notaFiscalRecebidaPlugNotasID: pagamento?.notaFiscalRecebida?.plugNotasID || "",
                dataCriacao: pagamento?.dataCriacaoFormatada || "",
                dataVencimento: pagamento?.dataVencimentoFormatada || "",
                valorDesconto: pagamento?.valorDesconto || 0,
                valorPagamento: pagamento?.valorPagamento || 0,
                valorReservado: pagamento?.valorReservado || 0,
                valorParaPagar: pagamento?.valorParaPagar || 0,
                valorPago: pagamento?.valorPago || 0,
                valorParaVincular: pagamento?.valorParaVincular || 0,
                valorVinculado: pagamento?.valorVinculado || 0,
            }

        });

        return{
            id: contaAPagar?.id || "", 
            aberto: false,
            codigo: contaAPagar?.codigo || "",
            parcelaCodigo: parcela?.codigo || "",
            status: contaAPagar?.status || "",
            forma: contaAPagar?.pagamentoForma || "",
            tipo: contaAPagar?.pagamentoTipo || "",
            evento: contaAPagar?.pagamentoEvento || "",
            descricao: contaAPagar?.descricao || "",
            dataVencimento: contaAPagar?.dataVencimentoFormatada || "",
            valorOriginal: contaAPagar?.valorOriginal || 0,
            valorParaReservar: contaAPagar?.valorParaReservar || 0,
            valorDesconto: contaAPagar?.valorDesconto || 0,
            valorPagamento: contaAPagar?.valorPagamento || 0,
            valorReservado: contaAPagar?.valorReservado || 0,
            valorParaPagar: contaAPagar?.valorParaPagar || 0,
            valorPago: contaAPagar?.valorPago || 0,
            valorParaVincular: contaAPagar?.valorParaVincular || 0,
            valorVinculado: contaAPagar?.valorVinculado || 0,
            liberadorNome: contaAPagar?.liberador?.nome || "",
            aprovadorNome: contaAPagar?.aprovador?.nome || "",
            reprovadorNome: contaAPagar?.reprovador?.nome || "",
            reprovadorJustificativa: contaAPagar?.reprovadorJustificativa || "",
            pagamentos: pagamentos || [],
            pagamentosQuantidade: contaAPagar?.pagamentosQuantidade || 0,
        }

    });

    dado = {
        id: dado?.id,
        tipo: dado?.tipo,
        codigo: dado?.codigo,
        contasAPagar: contasAPagar || []
    }

    alteraDado(dado);

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = ()=>{

    preparaDado(UtilObject.clone(props?.dadoOriginal));

}

//====================================================================//
//==== Prepara Modal se Dados Originais Carregados ou Recarregados ===//
//==================== Watch => visualizandoDado =====================//
//====================================================================//

watch(()=> props?.visualizandoDado, () => {

    if(props?.visualizandoDado == true){
        preparaModal();
    }

},{ immediate: true });

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.visualizandoDado"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :dado="dado"
                    @update:alteraVisualizandoDado="alteraVisualizandoDado"
                ></BarraNavegacao>

                <DadoConteudo
                    :dado="dado"
                    @update:alteraContaAPagar="alteraContaAPagar"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

/*==================================================================*/
/*============================= Dialog =============================*/
/*==================================================================*/

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>

